import Button from "@/lib/Button";
import OrganizationList from "./OrganizationList";
import Search from "@/lib/Search";
import useModal from "@/lib/modal/useModal";
import Edit from "./Edit";
import { useFetchOrganizations } from "@/lib/queries/hooks";
import ListingPage from "@/lib/layout/ListingPage";
import { useSearchParams } from "react-router";

export default function Organizations() {
  const { showModal, closeModal } = useModal();
  const [search, setSearch] = useSearchParams();

  const {
    data: organizations,
    isFetching,
    isLoading,
  } = useFetchOrganizations(search.get("search") || "");

  return (
    <ListingPage
      title="Customers"
      header={
        <div className="flex flex-wrap gap-3">
          <Search
            value={search.get("search") || ""}
            onChange={(value) =>
              value ? setSearch({ search: value }) : setSearch({})
            }
            className="min-w-50"
            isFetching={isFetching}
            focusable
            autoFocus
          />
          <Button primary onClick={() => showModal(<Edit done={closeModal} />)}>
            Add Customer
          </Button>
        </div>
      }
    >
      <OrganizationList
        data={organizations}
        isLoading={isLoading}
        nonDefaultFilters={!!search.get("search")}
      />
    </ListingPage>
  );
}
